import { useState, type FormEvent } from "react";
import { Navigate } from "react-router-dom";
import { AuthLayout, Button, Input, PasskeyLoginButton } from "@shop-ledger/ui-components";
import { useAuth } from "../auth/AuthContext";

export function LoginPage() {
  const { status, login, loginWithPasskey, loginPending, loginError } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  if (status === "authenticated") return <Navigate to="/" replace />;

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    try {
      await login(email, password);
    } catch {
      // loginError is already set by AuthContext; nothing further to do here.
    }
  }

  return (
    <AuthLayout
      eyebrow="Tenant sign-in"
      title="Welcome back"
      subtitle="Sign in to the admin back-office."
      tagline="Every sale, ledger entry, and stock count in one book — run the counter and the accounts from the same place."
      onSubmit={handleSubmit}
    >
      <Input
        label="Email"
        type="email"
        autoComplete="username"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <Input
        label="Password"
        type="password"
        autoComplete="current-password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      {loginError ? (
        <p className="banner banner--error" role="alert">
          {loginError}
        </p>
      ) : null}
      <Button type="submit" variant="primary" size="md" disabled={loginPending} style={{ width: "100%" }}>
        {loginPending ? "Signing in…" : "Sign in"}
      </Button>
      <PasskeyLoginButton onLoginWithPasskey={loginWithPasskey} disabled={loginPending} />
    </AuthLayout>
  );
}
